// LearnPage.jsx - Dynamic page component for Tier 1 & 2 educational content
import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getLandingPage, getRelatedPages } from '../../content/landingPages';
import { getPageContent } from '../../content/pageContent';
import LearnLayout from '../../layouts/LearnLayout';
import SEOHead from '../../components/seo/SEOHead';
import ArticleContent from '../../components/seo/ArticleContent';
import FAQSection from '../../components/seo/FAQSection';
import { SoftCTA } from '../../components/seo/CallToAction';

export default function LearnPage() {
  const { slug } = useParams();
  const page = getLandingPage(slug);

  // Redirect if page doesn't exist or is Tier 3 (solution page)
  if (!page) {
    return <Navigate to="/learn" replace />;
  }

  if (page.tier === 3) {
    return <Navigate to={`/solutions/${slug}`} replace />;
  }

  // Get the actual content
  const content = getPageContent(slug);
  const relatedPages = getRelatedPages(page.relatedSlugs || []);

  const relatedLinks = relatedPages.map(p => ({
    title: p.title,
    slug: p.tier === 3 ? `/solutions/${p.slug}` : `/learn/${p.slug}`,
    description: p.metaDescription?.substring(0, 80) + '...'
  }));

  return (
    <LearnLayout breadcrumb={page.title}>
      <SEOHead
        title={page.metaTitle}
        description={page.metaDescription}
        keywords={[page.keyword, 'medicare', 'retention', 'client retention']}
        canonicalUrl={`https://proirp.com/learn/${slug}`}
        publishedTime={page.publishedDate}
        faqItems={content?.faqs || []}
      />

      <ArticleContent
        title={page.title}
        author="Scott Fluegel"
        publishedDate={page.publishedDate}
        readTime={page.readTime}
        content={content?.html || '<p>Content coming soon...</p>'}
        relatedLinks={relatedLinks}
        sources={content?.sources || []}
        showAuthorBio={true}
        heroStyle={content?.heroStyle || 'default'}
        tag={content?.tag}
        stats={content?.stats}
      />

      {content?.faqs && content.faqs.length > 0 && (
        <FAQSection faqs={content.faqs} />
      )}

      <SoftCTA
        headline="This is why I'm building Pro IRP"
        description={content?.ctaDescription ||
          `After years in this industry, I got tired of watching good agents lose good clients for preventable reasons.
          Pro IRP is the retention platform I wish I had—built specifically for Medicare agents who want to
          protect their book of business and stop the churn.`
        }
      />
    </LearnLayout>
  );
}
